import { variantTypes } from 'shared/constants';
import { VIEW_SHADES, VIEW_SIZES } from 'shared/constants/strings';


const CONFIGURE_TYPE = {
  SHADE: 'shade',
  WEIGHT_CONFIGURE: 'weight_configure',
  SIZE:'size',
};


export const getVariantType = (variantType: string = '') => {
  if (variantType) {
    switch (variantType.toLowerCase()) {
      case CONFIGURE_TYPE.SHADE.toLowerCase():
        return variantTypes.SHADE;

      case CONFIGURE_TYPE.WEIGHT_CONFIGURE.toLowerCase():
      case CONFIGURE_TYPE.SIZE.toLowerCase():
        return variantTypes.SIZE;

      default:
        return;
    }
  }
};

export const getAllVariantLabel = ( variantType: string ) => {
  const type = getVariantType(variantType) || '';
  const label = (type.toLowerCase() === variantTypes.SHADE.toLowerCase()) ? VIEW_SHADES : VIEW_SIZES;
  return label;
};

export const isSize = (variantType = '') => (variantType.toLowerCase() === variantTypes.SIZE.toLocaleLowerCase());
